const Overlay = () => {
  return (
    <div className="fixed inset-0 bg-bg_shadow opacity-30 z-[1]"></div>
  );
};

export default Overlay;
